import {Component, Input, OnInit} from '@angular/core';
import {UtilConfig} from "../../../../../../autenticacion/servicios/UtilConfig";
import {Usuario} from "../../../../seguridad/usuario/recursos/modelo/usuario";

@Component({
    selector: 'app-print-ticket',
    templateUrl: './view/print.ticket.component.html',
    styleUrls: ['./css/print.ticket.component.scss']
})

export class PrintTicketComponent implements OnInit {

    @Input() document;

    @Input() totalLetter;

    cargoDescuentoGlobal = 0.0;
    recargoConsumo = 0.0;
    usuarioSession: Usuario;

    constructor(private util: UtilConfig) {
        this.usuarioSession = this.util.getCurrentUser();
    }


    ngOnInit() {
        if (this.document != null &&
            this.document.cab != null &&
            this.document.cab.cargoDescuento != null &&
            this.document.cab.cargoDescuento.length > 0) {
            this.document.cab.cargoDescuento.forEach((cargo) => {
                if (cargo.codigoCargoDescuento == '02') {
                    this.cargoDescuentoGlobal = cargo.montoCargoDescuento;
                }
                if (cargo.codigoCargoDescuento == '46') {
                    this.recargoConsumo = cargo.montoCargoDescuento;
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/boleta/componentes/ticket/print.ticket.component.ts